import React from 'react'
import PropTypes from 'prop-types'
import { Button, Text } from 'shared/components'

import * as styles from './styles'

const InWinButtonCell = ({ value, onRouteToUpdateEditForm }) => {
  return (
    <div css={styles.container}>
      <Button
        type="submit"
        small
        variation="primary"
        onClick={onRouteToUpdateEditForm}
        css={styles.customInwinButton}
        disabled={!value.inWinnable}
      >
        <Text size={11} upper bold>
          InWin
        </Text>
      </Button>
    </div>
  )
}

InWinButtonCell.propTypes = {
  value: PropTypes.any,
  onRouteToUpdateEditForm: PropTypes.func.isRequired,
}

export { InWinButtonCell }
